import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEarthEurope } from "@fortawesome/free-solid-svg-icons";
import styles from "./pageLanguageLink.module.scss";

function PageLanguageLink({ to }: { to: string }) {
    const { t, i18n } = useTranslation();
    const targetLang = i18n.language === "pt" ? "en" : "pt";

    return (
        <Link to={to} className={styles.link} lang={targetLang} hrefLang={targetLang}>
            <FontAwesomeIcon icon={faEarthEurope} className={styles.icon} aria-hidden="true" />
            {t("pageLanguageLink.label")}
        </Link>
    );
}

export default PageLanguageLink;
